<template>
  <v-select
    v-bind="$attrs"
    :value="value"
    :items="items"
    @input="selectChange"
    autocomplete="on"
  />
</template>

<script>
export default {
  name: 'CoverageAreaSelect',

  props: ['value'],

  data() {
    return {
      items: [ 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 125, 150 ]
    }
  },

  methods: {
    selectChange(newVal) {
      this.$emit('input', newVal)
    },
  },
}
</script>